/**
 * Login Page
 */

import { GuestGuard } from '@/components/auth';
import { LoginForm } from '@/components/auth';

export default function Login() {
  return (
    <GuestGuard>
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <LoginForm />
      </div>
    </GuestGuard>
  );
}
